/**
 * @generated SignedSource<<0893d3a0b586154ba3d103a2a58b555c>>
 * @relayHash ba5865dedf0d7ede066874789d1a8b38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 813acc5d904472fee552134e6bef5cd58169a1d0e2393ec695d211b13544ed4f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RecommendedAgentResultsJiraQuery$variables = {
  cloudId: string;
  contextAri: string;
};
export type RecommendedAgentResultsJiraQuery$data = {
  readonly jira: {
    readonly jira_recommendedAgentsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agent?: {
            readonly agentRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
            } | null;
            readonly deactivated?: boolean | null;
            readonly heroRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentHeroCard_StudioBrowseKit">;
            } | null;
            readonly id?: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type RecommendedAgentResultsJiraQuery = {
  response: RecommendedAgentResultsJiraQuery$data;
  variables: RecommendedAgentResultsJiraQuery$variables;
};
({
  "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isUpliftEnabled_provider from '@atlassian/studio-browse-kit/ui/agent-card/components/isAgentAuthorUpliftEnabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v2 = [
  {
    "kind": "Literal",
    "name": "assignableOnly",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "contextAri",
    "variableName": "contextAri"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "includeSemanticallyAvailable",
    "value": false
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "deactivated"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RecommendedAgentResultsJiraQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraActorConnection",
            "kind": "LinkedField",
            "name": "jira_recommendedAgentsV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraActorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "fragment": {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "kind": "FragmentSpread",
                                          "name": "AgentCardRelay_StudioBrowseKit"
                                        }
                                      ],
                                      "type": "AgentStudioAssistant"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "agentRef"
                                  },
                                  {
                                    "fragment": {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "kind": "FragmentSpread",
                                          "name": "AgentHeroCard_StudioBrowseKit"
                                        }
                                      ],
                                      "type": "AgentStudioAssistant"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "heroRef"
                                  }
                                ],
                                "type": "AgentStudioAssistant"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAgenticUser"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "RecommendedAgentResultsJiraQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraActorConnection",
            "kind": "LinkedField",
            "name": "jira_recommendedAgentsV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraActorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isVerified"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "icon"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "externalConfigReference"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "identityAccountId"
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "identityAccount",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v7/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "appType"
                                          }
                                        ],
                                        "type": "AppUser"
                                      },
                                      (v3/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "creatorType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "forgeCreator"
                                  },
                                  {
                                    "concreteType": "TeamV2",
                                    "kind": "LinkedField",
                                    "name": "authoringTeam",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                      },
                                      (v3/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountStatus"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                          }
                                        ]
                                      },
                                      (v3/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "__id"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AgentStudioAssistant"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAgenticUser"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "813acc5d904472fee552134e6bef5cd58169a1d0e2393ec695d211b13544ed4f",
    "metadata": {},
    "name": "RecommendedAgentResultsJiraQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
    }
  }
};
})();

(node as any).hash = "32488ac037c4f6443b4cad63568b8494";

export default node;
